import { jsx as _jsx } from "react/jsx-runtime";
import './AppMenuArrow.scss';
const AppMenuArrow = ({ modalIsOpen }) => {
    const arrowSymbol = modalIsOpen ? '⇡' : '⇣'; // ⇡⇣↑↓
    return _jsx("div", { className: "app-menu-arrow", children: arrowSymbol });
};
export default AppMenuArrow;
